import { useState, useRef } from "react";

export function JSONFormatter() {
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  function copyToClipboard() {
    navigator.clipboard.writeText(outputText);
  }

  function beautify() {
    if (!inputText.trim()) return;
    try {
      const parsed = JSON.parse(inputText);
      const beautified = JSON.stringify(parsed, null, 2);
      setOutputText(beautified);
    } catch (e) {
      setOutputText("Invalid JSON");
    }
  }

  function minify() {
    if (!inputText.trim()) return;
    try {
      const parsed = JSON.parse(inputText);
      const minified = JSON.stringify(parsed);
      setOutputText(minified);
    } catch (e) {
      setOutputText("Invalid JSON");
    }
  }

  function handleInputChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    setInputText(e.target.value);
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      if (textareaRef.current.clientHeight < textareaRef.current.scrollHeight) {
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
      }
    }
  }

  return (
    <div style={{
      maxWidth: '600px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{
        textAlign: 'center',
        color: '#333',
        marginBottom: '20px',
        fontSize: '24px'
      }}>
        JSON Formatter
      </h1>

      <div style={{
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <button
          onClick={beautify}
          style={{
            padding: '10px 20px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#45a049'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4CAF50'}
        >
          Beautify
        </button>
        <button
          onClick={minify}
          style={{
            padding: '10px 20px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1976D2'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2196F3'}
        >
          Minify
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 'bold',
          color: '#555'
        }}>
          Input JSON:
        </label>
        <textarea
          ref={textareaRef}
          placeholder="Paste your JSON here..."
          value={inputText}
          onChange={handleInputChange}
          style={{
            width: '90%',
            minHeight: '100px',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            resize: 'vertical',
            fontSize: '16px',
            fontFamily: 'inherit',
            outline: 'none',
            transition: 'border-color 0.3s'
          }}
          onFocus={(e) => e.currentTarget.style.borderColor = '#4CAF50'}
          onBlur={(e) => e.currentTarget.style.borderColor = '#ccc'}
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 'bold',
          color: '#555'
        }}>
          Output JSON:
        </label>
        <textarea
          placeholder="Formatted JSON will appear here..."
          value={outputText}
          onChange={(e) => setOutputText(e.target.value)}
          readOnly
          style={{
            width: '90%',
            minHeight: '100px',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            resize: 'vertical',
            fontSize: '16px',
            fontFamily: 'inherit',
            backgroundColor: '#f5f5f5',
            outline: 'none',
            color: 'black'
          }}
        />
      </div>

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={copyToClipboard}
          style={{
            padding: '10px 20px',
            backgroundColor: '#FF9800',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#E68900'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#FF9800'}
        >
          Copy Output
        </button>
      </div>
    </div>
  );
}